<template>
  <div class="tem-good-list">
    <!-- 商品列表 -->
    <div class="good-list" v-if="goodsList.length">
      <el-row :gutter="20">
        <el-col
          style="width: 20%"
          v-for="(item, index) in goodsList"
          :key="index"
          @click.native="goodDetail(item)"
        >
          <div class="goods-show-info">
            <div class="good-info-img">
              <img
                :src="
                  item.goodsPicture
                    ? item.goodsPicture
                    : 'static/img/bitmap.png'
                "
                alt=""
                class="good-img fit-contain"
              />
              <el-tag v-if="item.custspId" class="good-tag" effect="plain"
                >协议商品</el-tag
              >
            </div>
            <div class="good-info">
              <div class="good-info-name overell" :title="item.goodsName">
                {{ item.goodsName }}
              </div>
              <div class="good-info-price overell">
                <div>
                  <good-price
                    v-if="item.sellingPrice"
                    :price="item.sellingPrice || 0"
                    :losePrice="item.originPrice || 0"
                    :discountRate="item.discountRate|| 0"
                  >
                  </good-price>
                  <span class="price" v-else>待询价</span>
                </div>
              </div>
            </div>
            <div class="offSale" v-if="item.offSale">
              <span>已下架</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import GoodPrice from "@/components/good-price/goodPrice";
import { openOther } from "@/utils/index";
export default {
  data() {
    return {};
  },
  props: {
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    GoodPrice,
  },
  methods: {

    // 进入商品详情页
    goodDetail(good) {
      // 下架不跳转
      if (good && !good.offSale) {
        openOther(`goodDetail?spuId=${good.spuId}&skuId=${good.skuId || ""}`);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.tem-good-list {
  .good-list {
    background: #fff;

    .goods-show-info {
      margin-bottom: 10px;
      height: 280px;
      cursor: pointer;
      -webkit-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
      -moz-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
      box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
      position: relative;

      &:hover {
        -webkit-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
        -moz-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
        box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      }

      .offSale {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
        font-weight: bold;
        color: #e33135;
      }

      .good-info-img {
        background: #fff;
        width: 100%;
        height: 200px;
        position: relative;
        .good-img {
          width: 100%;
          height: 200px;
        }
        .good-tag {
          position: absolute;
          right: 4px;
          bottom: 4px;
          border-color: #2a54d1;
          color: #2a54d1;
        }
      }

      .good-info {
        background: #fff;
        margin-top: 3px;
        padding: 10px;

        .good-info-name {
          font-size: 14px;
          color: #333333;
          letter-spacing: 0.2px;
          line-height: 20px;
        }

        .good-info-price {
          font-size: 18px;
          color: #e33135;
          letter-spacing: 0.2px;
          line-height: 30px;
          font-weight: bold;

          .good-info-price-activity {
          }

          /deep/ .price {
            margin-top: 4px;
            color: #e64c3a;
            font-weight: bold;
            font-size: 18px;
            display: inline-block;

            .price-int {
              // font-size: 18px;
            }

            .price-point {
              // font-size: 10px;
            }
          }

          .good-info-price-original {
            color: #ccc;
            font-size: 12px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
</style>
<style>
.tem-good-list .el-divider__text {
  background: #f9f9f9 !important;
}
</style>
